import { useEffect, useRef, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { useHistory, useLocation } from 'react-router-dom'
import { Button } from '@components/v2/button'
import { OtpInput } from '@components/v2/otp-input'
import { useLogin } from 'login/hooks/useLogin'
import { t } from '@lingui/core/macro'

export function Login() {
  const location = useLocation()
  const history = useHistory()
  const { loginForm, handleLoginFormChange, handleLogin, loading } = useLogin()
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true)
  const inputRef = useRef<HTMLInputElement>(null)

  if (!loginForm.email || !loginForm.password) {
    history.replace(`/auth/login${location.search}`)
  }

  useEffect(() => {
    inputRef.current?.focus()
  }, [inputRef?.current])

  return (
    <motion.form
      onSubmit={e => {
        handleLogin(e, true)
      }}
      className="flex flex-col gap-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
    >
      <AnimatePresence initial={false}>
        <div className="relative flex flex-col gap-2 text-cv-blue-600">
          <h2 className="font-bold text-[14px] mb-2">{t`Multi-factor authentication code`}</h2>
          <OtpInput
            name="mfa_code"
            inputRef={inputRef}
            onChange={value => {
              handleLoginFormChange('mfa_code', value)
            }}
            onComplete={() => {
              setIsSubmitDisabled(false)
            }}
            value={loginForm.mfa_code}
          />
        </div>
        <div className="flex justify-center">
          <Button disabled={isSubmitDisabled} type="submit" variant="primary" isLoading={loading}>
            {t`Login`}
          </Button>
        </div>
      </AnimatePresence>
    </motion.form>
  )
}
